module.exports = "<my-select class=\"col s12\"\n  ng-model=\"myWagon.ownerId\"\n  my-options=\"fieldsOptions.ownerId\"\n  my-data=\"owners\"\n  enable-validator=\"enableValidator\">\n</my-select>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/entities/trains/wagon/directives/search/myWagonOwnerSearch.html
// module id = 1127
// module chunks = 0